var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPutAway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_552_7939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#ECEFF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_552_7939)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 60,
    r: 50,
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9654 49.9307C55.5442 49.9307 64.9307 40.5442 64.9307 28.9654C64.9307 17.3865 55.5442 8 43.9654 8C32.3865 8 23 17.3865 23 28.9654C23 40.5442 32.3865 49.9307 43.9654 49.9307Z",
    fill: "#4FBA6F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3801 28.965C58.3801 30.4123 57.2068 31.5856 55.7594 31.5856H46.5871V40.758C46.5871 42.2053 45.4138 43.3786 43.9664 43.3786C42.5191 43.3786 41.3458 42.2053 41.3458 40.758V31.5856H32.1734C30.726 31.5856 29.5527 30.4123 29.5527 28.965C29.5527 27.5176 30.726 26.3443 32.1734 26.3443H41.3458V17.1719C41.3458 15.7246 42.5191 14.5513 43.9664 14.5513C45.4138 14.5513 46.5871 15.7246 46.5871 17.1719V26.3443H55.7594C57.2068 26.3443 58.3801 27.5176 58.3801 28.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8617 61.2413V78.9309C86.8617 89.0624 78.6485 97.2756 68.517 97.2756H59.3447C49.2132 97.2756 41 89.0624 41 78.9309V69.0509C41.0021 65.2334 43.373 61.818 46.9489 60.4813L47.1324 60.4158L47.5517 60.2586L50.1723 59.2758V41.5863C50.1723 39.0534 52.2256 37.0001 54.7585 37.0001C55.4408 36.9948 56.1145 37.152 56.724 37.4587C57.1984 37.6759 57.6291 37.9779 57.995 38.3498C58.8608 39.2039 59.3471 40.3701 59.3447 41.5863V56C59.3447 53.4671 61.398 51.4138 63.9309 51.4138C65.1434 51.4295 66.303 51.913 67.1674 52.7635C68.0332 53.6176 68.5195 54.7838 68.517 56V57.3103C68.5128 55.3698 69.7382 53.6395 71.5701 52.9993C73.2346 52.4154 75.0864 52.8326 76.3397 54.0738C77.2055 54.9279 77.6918 56.0941 77.6894 57.3103V61.2413C77.6894 58.7085 79.7427 56.6552 82.2756 56.6552C84.8034 56.6673 86.8495 58.7135 86.8617 61.2413Z",
    fill: "#FFDAAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.689 57.3102V68.448C77.689 69.1717 77.1024 69.7584 76.3787 69.7584C75.655 69.7584 75.0684 69.1717 75.0684 68.448V53.1826C75.5427 53.3998 75.9735 53.7018 76.3394 54.0736C77.2052 54.9278 77.6915 56.094 77.689 57.3102Z",
    fill: "#FBCC94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5162 56.0001V65.8276C68.5162 66.5513 67.9295 67.138 67.2058 67.138C66.4822 67.138 65.8955 66.5513 65.8955 65.8276V51.8726C66.3699 52.0897 66.8006 52.3917 67.1665 52.7636C68.0323 53.6177 68.5186 54.7839 68.5162 56.0001Z",
    fill: "#FBCC94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3433 41.5865V64.5174C59.3433 65.2411 58.7567 65.8277 58.033 65.8277C57.3093 65.8277 56.7227 65.2411 56.7227 64.5174V37.459C57.197 37.6762 57.6278 37.9781 57.9937 38.35C58.8595 39.2042 59.3458 40.3703 59.3433 41.5865Z",
    fill: "#FBCC94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1715 59.2764V77.6211C50.1715 78.3447 49.5848 78.9314 48.8611 78.9314C48.1374 78.9314 47.5508 78.3447 47.5508 77.6211V60.2591L50.1715 59.2764Z",
    fill: "#FBCC94"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPutAway);
export default __webpack_public_path__ + "static/media/putAway.452878293beb7300797adda9def29717.svg";
export { ForwardRef as ReactComponent };